// extracted by mini-css-extract-plugin
export default {"profileGroup":"profileInfo_profileGroup__4ec8r","info":"profileInfo_info__pViSy","infoName":"profileInfo_infoName__MD69T","infoDesc":"profileInfo_infoDesc__aWmNL"};